import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCurrentUser,
  selectIsSuperadmin,
} from "../store/slices/authSlice";

export default function SuperAdminRoute({ children }) {
  const dispatch = useDispatch();
  const isSuperadmin = useSelector(selectIsSuperadmin);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(fetchCurrentUser()).finally(() => setLoading(false));
  }, [dispatch]);

  if (loading) return null;

  if (!isSuperadmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
